<template>
  <div class="bg-features w-full pb-20">
    <div class="max-w-7xl mx-auto px-6 md:px-0">
      <div class="grid grid-cols-1 md:grid-cols-3">
        <div class="text-left col-start-1 flex flex-col">
          <p class="text-md text-white font-poppins tracking-widest">FEATURES</p>
          <img class="w-1/2 -ml-1 py-2" src="https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/smartliving.png"/>
        </div>
        <div class="text-left col-span-2 ">
          <p class="text-md text-white font-poppins tracking-normal max-w-sm pt-6">Enjoy streaming, working, gaming, and connecting with loved ones, all powered effortlessly.</p>
        </div>
      </div>
    </div>
    <div class="max-w-7xl mx-auto px-6 md:px-0">
      <dl class="my-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-2 sm:gap-y-6 lg:grid-cols-3 lg:gap-x-8">
        <div v-for="feature in features" :key="feature.name" class="relative">
          <div class="group transition ease-in-out duration-100 hover:rounded-2xl hover:bg-gradient-to-tr hover:from-brand-primary-light hover:to-brand-primary-dark hover:p-1 shadow-lg">
            <div class="bg-white bg-opacity-70 rounded-xl pt-10 pb-10 px-6 md:px-8 group-hover:bg-opacity-100 relative transition-opacity ease-in-out duration-0 ">
              <div class="relative h-36">
                <img class="absolute inset-0 opacity-100 group-hover:opacity-0 transition-opacity ease-in-out duration-300" :src=feature.img />
                <img class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity ease-in-out duration-300" :src=feature.imghover />
              </div>
              <div>
                <p class="py-2 lg:py-0 text-2xl leading-6 font-poppins text-black font-bold">{{ feature.name }}</p>
              </div>
              <div class="mt-0 max-w-xs font-poppins text-sm lg:text-base text-black h-20 lg:h-36 pb-2 lg:pb-2">
                {{ feature.description }}
              </div>
              <button type="button" onclick="javascript:document.getElementById('primary-address-search').focus()" class="shadow-sm transition duration-500 ease-in-out w-full text-center items-center justify-center px-4 py-3 md:text-md rounded-full text-black bg-transparent group-hover:bg-brand-button-hover group-hover:text-white md:text-18 md:px-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-brand-accent border border-black font-poppins text-18 group-hover:mt-4 group-hover:mb-4 hover:cursor-pointer">
                  Check your Address
              </button>
            </div>
          </div>
        </div>
      </dl>
    </div>

  </div>
</template>

<script setup lang="ts">
import Title from '../../components/content/Title.vue';
import Container from '../../components/content/Container.vue';
import { CheckIcon } from '@heroicons/vue/outline';
import { defineProps } from 'vue';

type FeaturesData = {
  features: Array<{
    name: string,
    description: string,
    img: string,
    imghover: string
  }>,
  header: {
    headline: string,
    tagline: string
  }
}

defineProps<FeaturesData>();

</script>

<style scoped>
.bg-features {
  background-color: #000;
  background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/features-bg.png");
  background-position: center;
  background-size: cover;
  height: auto;
}
</style>
